import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { FC } from "react";
import { NavLink } from "react-router-dom";

// <--- NavItemType --->
export interface MegamenuItem {
  id: string;
  image: string;
  title: string;
  items: NavItemType[];
}
export interface NavItemType {
  id: string;
  name: string;
  isNew?: boolean;
  href?: string;
  targetBlank?: boolean;
  children?: NavItemType[];
  megaMenu?: MegamenuItem[];
  onClick?: () => void; // Add onClick to NavItemType
  type?: "dropdown" | "megaMenu" | "none";
}

export interface NavigationItemProps {
  menuItem: NavItemType;
}

type NavigationItemWithRouterProps = NavigationItemProps;

const NavigationItem: FC<NavigationItemWithRouterProps> = ({ menuItem }) => {
  // ===================== MENU MAIN MENU =====================
  const renderMainItem = (item: any) => {
    return item.type === "dropdown" ? (
      <div className="inline-flex items-center whitespace-nowrap text-sm xl:text-[15px] font-medium text-white py-2 px-3 xl:px-4 rounded-full hover:text-white hover:bg-neutral-100 ">
        {item.name}
        <ChevronDownIcon
          className="ml-1 -mr-1 h-4 w-4 text-text-color"
          aria-hidden="true"
        />
      </div>
    ) : (
      <NavLink
        end
        target={item.targetBlank ? "_blank" : undefined}
        rel="noopener noreferrer"
        className={({ isActive }) =>
          // Underline shows on hover only. Active state uses a slightly bolder
          // weight instead of a permanent line — the previous "active" border
          // was lighting up under every nav item that pointed to "/" or "/#…",
          // which happens any time you're on the home page.
          `inline-flex items-center whitespace-nowrap text-sm xl:text-[15px] font-semibold !text-navigation-text-color py-2 px-3 xl:px-4 rounded-none border-b-2 border-transparent transition-colors duration-200 hover:border-primary-brand ${
            isActive ? "!font-bold" : ""
          }`
        }
        to={item?.url || "/"}
      >
        {item.name}
      </NavLink>
    );
  };

  switch (menuItem.type) {
    default:
      return <span className="menu-item">{renderMainItem(menuItem)}</span>;
  }
};

// Your component own properties

export default NavigationItem;
